module.exports = __webpack_public_path__ + "img/battants.7f98c75.svg";